// Bundle Accessories Loader
// Fetches matching accessories via Storefront API and renders bundle section

(function() {
  // Storefront API configuration
  const STOREFRONT_CONFIG = {
    accessToken: '2b1655cbba33534d0f333a7c65212f11',
    apiVersion: '2025-01',
    shopDomain: 'newbegininng2021.myshopify.com'
  };

  // Request cache to avoid duplicate queries
  const requestCache = new Map();
  let lastRequestTime = 0;
  const MIN_REQUEST_INTERVAL = 500;

  /**
   * Fetch data from Storefront API with rate limiting and caching
   */
  async function fetchFromStorefront(query, variables = {}) {
    const cacheKey = JSON.stringify({ query, variables });
    if (requestCache.has(cacheKey)) {
      return requestCache.get(cacheKey);
    }

    // Rate limiting
    const now = Date.now();
    const timeSinceLastRequest = now - lastRequestTime;
    if (timeSinceLastRequest < MIN_REQUEST_INTERVAL) {
      await new Promise(resolve =>
        setTimeout(resolve, MIN_REQUEST_INTERVAL - timeSinceLastRequest)
      );
    }

    try {
      const response = await fetch(
        `https://${STOREFRONT_CONFIG.shopDomain}/api/${STOREFRONT_CONFIG.apiVersion}/graphql.json`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_CONFIG.accessToken
          },
          body: JSON.stringify({ query, variables })
        }
      );

      lastRequestTime = Date.now();

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.errors) {
        console.error('GraphQL errors:', data.errors);
        throw new Error('GraphQL query failed');
      }

      requestCache.set(cacheKey, data);
      return data;

    } catch (error) {
      console.error('Storefront API error:', error);
      throw error;
    }
  }

  /**
   * Fetch accessories matching the material type
   */
  async function fetchMatchingAccessories(materialType) {
    const query = `
      query FetchBundleAccessories {
        products(
          first: 50,
          query: "tag:${materialType}"
        ) {
          edges {
            node {
              id
              title
              handle
              tags
              availableForSale
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              featuredImage {
                url(transform: { maxWidth: 600, maxHeight: 600 })
                altText
              }
              variants(first: 10) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    price {
                      amount
                      currencyCode
                    }
                    compareAtPrice {
                      amount
                      currencyCode
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    try {
      const response = await fetchFromStorefront(query);

      // Filter for exact matches: must have both bundle-accessory tag AND matching material tag
      const products = response.data.products.edges
        .map(edge => edge.node)
        .filter(product => {
          const tags = product.tags || [];
          const hasAccessoryTag = tags.some(tag => tag.startsWith('bundle-accessory-'));
          const hasMaterialTag = tags.includes(materialType);
          return hasAccessoryTag && hasMaterialTag && product.availableForSale;
        })
        .sort((a, b) => {
          // Sort by accessory type: belts first, then cardholders, then wallets
          const getTypePriority = (tags) => {
            if (tags.includes('bundle-accessory-belt')) return 1;
            if (tags.includes('bundle-accessory-cardholder')) return 2;
            if (tags.includes('bundle-accessory-wallet')) return 3;
            return 4;
          };
          return getTypePriority(a.tags) - getTypePriority(b.tags);
        });

      return products;

    } catch (error) {
      console.error('Error fetching accessories:', error);
      return [];
    }
  }

  /**
   * Render the bundle section with products
   */
  function renderBundleSection(products, materialType, isDesktop = false) {
    const bundleContainer = document.getElementById(isDesktop ? 'bundle-section-desktop' : 'bundle-section-mobile');
    if (!bundleContainer) return;

    // Get main product price data from the container
    const mainProductPrice = parseFloat(bundleContainer.dataset.mainPrice || 0);
    const mainProductCompareAtPrice = parseFloat(bundleContainer.dataset.mainCompareAtPrice || 0);

    // Calculate main product savings (if compare_at_price exists and is higher)
    let mainProductSavings = 0;
    if (mainProductCompareAtPrice > mainProductPrice) {
      mainProductSavings = mainProductCompareAtPrice - mainProductPrice;
    }

    // Calculate total savings across all accessories
    // Savings = compare_at_price - (current_price * 0.90)
    let totalSavings = 0;
    products.forEach(product => {
      const currentPrice = parseFloat(product.priceRange.minVariantPrice.amount);
      const compareAtPrice = product.variants.edges[0]?.node.compareAtPrice
        ? parseFloat(product.variants.edges[0].node.compareAtPrice.amount)
        : null;

      if (compareAtPrice && compareAtPrice > currentPrice) {
        const discountedPrice = currentPrice * 0.90;
        const savings = compareAtPrice - discountedPrice;
        totalSavings += savings;
      } else {
        // If no compare at price, savings is just 10% off current price
        totalSavings += (currentPrice * 0.10);
      }
    });

    // Different styling for desktop (wider, more compact)
    const gridColumns = isDesktop ? '1fr' : 'repeat(auto-fill, minmax(200px, 1fr))';
    const titleSize = isDesktop ? '20px' : '18px';
    const subtitleSize = isDesktop ? '14px' : '15px';

    const totalSavingsWithMain = (totalSavings + mainProductSavings).toFixed(2);

    let html = `
      <div class="bundle-section-wrapper" style="margin: 20px 0; padding: ${isDesktop ? '20px' : '16px'}; background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%); border-radius: 12px; border: 2px solid #000000;">
        <div class="bundle-header" style="display: flex; ${isDesktop ? 'justify-content: center;' : 'flex-direction: column;'} align-items: center; cursor: ${isDesktop ? 'default' : 'pointer'}; margin-bottom: 0; ${isDesktop ? 'text-align: center;' : ''}" onclick="${isDesktop ? '' : 'toggleBundleContent(this)'}">
          ${isDesktop ? `
            <h3 style="font-size: ${titleSize}; margin-bottom: 0; margin-top: 0; color: #212529; font-weight: 700;">Допълни своя аутфит</h3>
          ` : `
            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
              <h3 style="font-size: ${titleSize}; margin-bottom: 0; margin-top: 0; color: #212529; font-weight: 700; text-align: center; flex: 1;">Допълни своя аутфит</h3>
              <div class="bundle-toggle" style="font-size: 18px; color: #6c757d; transition: transform 0.3s;">▼</div>
            </div>
            <p class="bundle-savings-label" style="color: #c81853; font-size: 14px; font-weight: bold; margin: 2px 0 0 0;">Спести ОБЩО ${totalSavingsWithMain} €</p>
            <p class="bundle-hint-label" style="color: #000000; font-size: 12px; margin: 0; font-style: italic;">(Натисни за повече информация)</p>
          `}
        </div>

        <div class="bundle-content" style="display: ${isDesktop ? 'block' : 'none'};">
          ${isDesktop ? '' : `<p style="color: #6c757d; font-size: ${subtitleSize}; margin-top: 8px; margin-bottom: 12px; text-align: center;">Твоята чанта много ще си отива с:</p>`}
          ${isDesktop ? `<p style="color: #6c757d; font-size: ${subtitleSize}; margin-top: 4px; margin-bottom: 16px; text-align: center;">Твоята чанта много ще си отива с:</p>` : ''}
          <div class="bundle-grid" style="${isDesktop ? 'display: flex; flex-direction: column; align-items: center;' : 'display: grid;'} ${!isDesktop ? 'grid-template-columns: ' + gridColumns + ';' : ''} gap: 0;">
    `;

    products.forEach((product, productIndex) => {
      const allVariants = product.variants.edges.map(edge => edge.node);
      const firstVariant = allVariants[0];
      const hasMultipleVariants = allVariants.length > 1;

      const currentPrice = parseFloat(product.priceRange.minVariantPrice.amount);
      const currency = product.priceRange.minVariantPrice.currencyCode;
      const discountedPrice = currentPrice * 0.90;
      const compareAtPrice = firstVariant?.compareAtPrice
        ? parseFloat(firstVariant.compareAtPrice.amount)
        : null;
      const variantId = firstVariant?.id;
      const available = firstVariant?.availableForSale;
      const imageUrl = product.featuredImage?.url || '';
      const imageAlt = product.featuredImage?.altText || product.title;

      // Calculate total savings (accessory + main product)
      let accessorySavings = 0;
      if (compareAtPrice && compareAtPrice > currentPrice) {
        accessorySavings = compareAtPrice - discountedPrice;
      } else {
        accessorySavings = currentPrice * 0.10;
      }
      const totalSavingsAmount = accessorySavings + mainProductSavings;

      // Extract Shopify variant ID from GID
      const numericVariantId = variantId ? variantId.split('/').pop() : '';

      const itemStyle = isDesktop
        ? `width: 100%; max-width: 700px; background: white; border-radius: 8px; padding: 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); transition: transform 0.2s, box-shadow 0.2s; cursor: pointer; display: flex; gap: 20px; align-items: center;`
        : `background: white; border-radius: 8px; padding: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); transition: transform 0.2s, box-shadow 0.2s; cursor: pointer;`;

      const imageContainerStyle = isDesktop
        ? `flex: 1; min-width: 0;`
        : ``;

      const imageStyle = isDesktop
        ? `width: 100%; height: auto; aspect-ratio: 1; object-fit: cover; border-radius: 6px;`
        : `width: 100%; height: 200px; object-fit: cover; border-radius: 6px; margin-bottom: 10px;`;

      const contentStyle = isDesktop
        ? `flex: 1; display: flex; flex-direction: column; gap: 8px; min-width: 0;`
        : ``;

      html += `
        <div class="bundle-item" style="${itemStyle}"
             onmouseover="this.style.transform='translateY(-4px)'; this.style.boxShadow='0 4px 16px rgba(0,0,0,0.12)';"
             onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 8px rgba(0,0,0,0.08)';">

          ${isDesktop ? `
            <div style="${imageContainerStyle}">
              <a href="/products/${product.handle}">
                <img src="${imageUrl}"
                     alt="${imageAlt}"
                     loading="lazy"
                     style="${imageStyle}">
              </a>
            </div>
          ` : `
            <a href="/products/${product.handle}" style="text-decoration: none; color: inherit;">
              <img src="${imageUrl}"
                   alt="${imageAlt}"
                   loading="lazy"
                   style="${imageStyle}">
            </a>
          `}

          <div style="${contentStyle}">
              ${isDesktop ? `
                <h4 style="font-size: 14px; margin: 0; color: #212529; line-height: 1.3; font-weight: 600;">${product.title}</h4>
              ` : `
                <a href="/products/${product.handle}" style="text-decoration: none; color: inherit;">
                  <h4 style="font-size: 14px; margin: 8px 0; min-height: 36px; color: #212529; line-height: 1.3; font-weight: 600;">${product.title}</h4>
                </a>
              `}

              <div class="pricing" style="margin: ${isDesktop ? '0' : '10px 0'}; padding: 10px; background: #f8f9fa; border-radius: 6px; text-align: center;">
                <div style="font-size: 16px; color: #495057; margin-bottom: 8px; display: flex; justify-content: center; align-items: center; gap: 8px;">
                  <span style="text-decoration: line-through; font-weight: 600;">${formatMoney(currentPrice, currency)}</span>
                  <span style="color: #212529; font-weight: 700; font-size: 18px;">${formatMoney(discountedPrice, currency)}</span>
                </div>
                <div style="font-size: 15px; color: #28a745; font-weight: 700; padding: 8px; background: white; border-radius: 4px;">
                  Спестяваш ОБЩО: ${formatMoney(totalSavingsAmount, currency)}
                </div>
              </div>

              ${hasMultipleVariants ? `
                <div class="variant-selector" style="margin: ${isDesktop ? '12px 0' : '12px 0'};">
                  <label style="display: block; font-size: 13px; font-weight: 600; color: #495057; margin-bottom: 8px;">
                    Избери размер:
                  </label>
                  <select class="bundle-variant-select" data-product-index="${productIndex}"
                          style="width: 100%; padding: 10px 12px; border: 2px solid #dee2e6; border-radius: 6px; font-size: 14px; font-weight: 500; background: white; cursor: pointer; transition: border-color 0.2s;">
                    ${allVariants.map((variant, idx) => {
                      const sizeOption = variant.selectedOptions.find(opt => opt.name.toLowerCase() === 'size');
                      const sizeLabel = sizeOption ? sizeOption.value : variant.title;
                      const variantGid = variant.id;
                      const numericId = variantGid.split('/').pop();
                      const isAvailable = variant.availableForSale;

                      return `<option value="${numericId}" ${idx === 0 ? 'selected' : ''} ${!isAvailable ? 'disabled' : ''}>
                        ${sizeLabel}${!isAvailable ? ' - Изчерпан' : ''}
                      </option>`;
                    }).join('')}
                  </select>
                </div>
              ` : ''}

              ${available ? `
                <button class="bundle-add-btn button"
                        data-variant-id="${numericVariantId}"
                        data-product-title="${escapeHtml(product.title)}"
                        style="width: ${isDesktop ? 'auto' : '100%'}; ${isDesktop ? 'min-width: 160px;' : ''} background-color: #000000; border-color: #000000; border-radius: 25px; font-size: 14px; padding: 12px 20px; transition: all 0.3s ease;">
                  Добави комплект
                </button>
              ` : `
                <button disabled class="button" style="width: ${isDesktop ? 'auto' : '100%'}; background-color: #e0e0e0; color: #999; cursor: not-allowed; border-radius: 25px; padding: 12px 20px;">
                  Изчерпан
                </button>
              `}
            </div>
          </div>

          <div style="width: 100%; text-align: center; margin-top: 8px; font-size: 12px; color: #6c757d; padding-top: 2px; border-top: 1px solid #e9ecef;">
            ✓ Отстъпката се прилага автоматично при плащане
          </div>
        </div>
      `;
    });

    html += `
          </div>
        </div>
      </div>
    `;

    bundleContainer.innerHTML = html;
    attachAddToCartHandlers(bundleContainer);
  }

  /**
   * Attach click handlers to "Add Bundle" buttons
   */
  function attachAddToCartHandlers(container) {
    // Handle variant selector changes
    container.querySelectorAll('.bundle-variant-select').forEach(select => {
      select.addEventListener('change', function() {
        // Update the button's variant ID when selection changes
        const bundleItem = this.closest('.bundle-item');
        const addButton = bundleItem.querySelector('.bundle-add-btn');
        if (addButton) {
          addButton.dataset.variantId = this.value;
        }
      });
    });

    container.querySelectorAll('.bundle-add-btn').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        // Get variant ID from selector if available, otherwise use button's data
        const bundleItem = this.closest('.bundle-item');
        const variantSelect = bundleItem ? bundleItem.querySelector('.bundle-variant-select') : null;
        const accessoryVariantId = variantSelect ? variantSelect.value : this.dataset.variantId;
        const originalText = this.textContent;

        // Get main product variant ID from the specific bundle section (container passed to function)
        const mainVariantId = container.dataset.mainVariantId;

        if (!mainVariantId) {
          showNotification('Грешка: Не може да се намери основният продукт.', true);
          return;
        }

        this.textContent = 'Добавя се...';
        this.disabled = true;

        // Add both products to cart (main product + accessory)
        const items = [
          { id: mainVariantId, quantity: 1 },
          { id: accessoryVariantId, quantity: 1 }
        ];

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(response => {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(data => {
          this.textContent = '✓ Добавен!';
          this.style.backgroundColor = '#4CAF50';
          this.style.borderColor = '#4CAF50';

          // Get the items that were added (array of 2 items)
          const items = data.items || [];

          // Show theme modal if available
          if (typeof showThemeModal === 'function' && items.length > 0) {
            // Use the first item (handbag) for the modal display
            const mainProduct = items[0];
            const accessoryProduct = items[1];

            const thumbUrl = mainProduct.featured_image?.url || mainProduct.image;
            const offset = 25;

            // Build variant info
            let variantHtml = '';
            if (accessoryProduct && accessoryProduct.product_title) {
              variantHtml += `<p class="cart-product__content__meta">+ ${accessoryProduct.product_title}</p>`;
            }

            // Calculate pricing for display
            const totalOriginalPrice = mainProduct.original_price + accessoryProduct.original_price;
            const totalFinalPrice = mainProduct.final_price + accessoryProduct.final_price;
            const hasDiscount = totalFinalPrice < totalOriginalPrice;

            const regularPrice = (totalOriginalPrice / 100).toFixed(2) + ' €';
            const discountedPrice = (totalFinalPrice / 100).toFixed(2) + ' €';

            let priceHtml = '';
            if (hasDiscount) {
              priceHtml = '<p><span style="text-decoration:line-through;color:black">' + regularPrice + '</span>' +
                          '<span style="margin-left: 8px;font-weight:bold">' + discountedPrice + '</span>' + '</p>';
            }

            const modalHtml = [
              '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">',
              `<div class="inner" style="top:${offset}px">`,
              '<a href="#" data-modal-close class="modal-close">&times;</a>',
              `<h4 id="added-to-cart-title">${theme.icons.tick}${theme.strings.productAddedToCart}</h4>`,
              '<div class="cart-product">',
              `<div class="cart-product__image"><img src="${thumbUrl}" alt="${mainProduct.product_title}"/></div>`,
              '<div class="cart-product__content">' +
              `<p class="cart-product__content__title">${mainProduct.product_title}</p>` +
              variantHtml +
              '<p style="color:#c81853;text-align:left;font-size:13px;font-weight:bold">Комплект с 10% отстъпка!</p>' +
              priceHtml +
              '</div>',
              '</div>',
              '<p class="links">',
              `<a href="${theme.routes.cart_url}" class="button alt">${theme.strings.viewCart}</a>`,
              `<a href="${theme.routes.checkout}" class="button button--checkout" [data-cc-checkout-button]>${theme.strings.popupCheckout}</a>`,
              '</p>',
              '</div>',
              '</div>'
            ].join('');

            showThemeModal(modalHtml, "added-to-cart", null);
          } else {
            showNotification(`Комплектът е добавен в количката!`);
          }

          // Update cart count
          const shopifyAjaxStorePageURL = window.location.origin + window.location.pathname + '?view=ajax';
          fetch(shopifyAjaxStorePageURL)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newCartEl = doc.querySelector('#site-control .cart:not(.nav-search)');
              const currentCartEl = document.querySelector('#site-control .cart:not(.nav-search)');
              if (newCartEl && currentCartEl) {
                currentCartEl.replaceWith(newCartEl);
              }
            });

          setTimeout(() => {
            this.textContent = 'Добави комплект';
            this.disabled = false;
            this.style.backgroundColor = '#000000';
            this.style.borderColor = '#000000';
          }, 2000);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          this.textContent = originalText;
          this.disabled = false;
          showNotification('Грешка при добавяне. Моля опитайте отново.', true);
        });
      });
    });
  }

  /**
   * Show notification message
   */
  function showNotification(message, isError = false) {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${isError ? '#f44336' : '#4CAF50'};
      color: white;
      padding: 15px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      z-index: 9999;
      animation: slideInRight 0.3s ease-out;
      max-width: 300px;
      font-size: 14px;
    `;
    notification.textContent = message;

    // Add animation styles if not already present
    if (!document.getElementById('bundle-notification-styles')) {
      const style = document.createElement('style');
      style.id = 'bundle-notification-styles';
      style.textContent = `
        @keyframes slideInRight {
          from { transform: translateX(400px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideInRight 0.3s ease-out reverse';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  /**
   * Format money amount with BGN conversion
   */
  function formatMoney(amount, currency) {
    const EUR_TO_BGN_RATE = 1.95583;

    // Format EUR amount using Shopify's format if available
    let eurFormatted;
    if (window.theme && window.theme.moneyFormat) {
      eurFormatted = window.theme.moneyFormat.replace('{{amount}}', amount.toFixed(2));
    } else {
      eurFormatted = new Intl.NumberFormat('bg-BG', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    }

    // Calculate BGN amount
    const bgnAmount = (amount * EUR_TO_BGN_RATE).toFixed(2);

    return `${eurFormatted} / ${bgnAmount} лв.`;
  }

  /**
   * Escape HTML to prevent XSS
   */
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Initialize bundle section on page load
   */
  document.addEventListener('DOMContentLoaded', function() {
    // Check for both desktop and mobile containers
    const bundleContainerDesktop = document.getElementById('bundle-section-desktop');
    const bundleContainerMobile = document.getElementById('bundle-section-mobile');

    const bundleContainer = bundleContainerDesktop || bundleContainerMobile;
    if (!bundleContainer) return;

    const materialType = bundleContainer.dataset.materialType;
    if (!materialType) {
      if (bundleContainerDesktop) bundleContainerDesktop.style.display = 'none';
      if (bundleContainerMobile) bundleContainerMobile.style.display = 'none';
      return;
    }

    // Show loading state
    bundleContainer.innerHTML = `
      <div style="text-align: center; padding: 30px; color: #6c757d;">
        <div style="display: inline-block; width: 36px; height: 36px; border: 3px solid #f3f3f3; border-top: 3px solid #667eea; border-radius: 50%; animation: spin 1s linear infinite;"></div>
        <p style="margin-top: 12px; font-size: 14px;">Зареждане на съвпадащи аксесоари...</p>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;

    // Fetch and render accessories
    fetchMatchingAccessories(materialType)
      .then(products => {
        if (products.length === 0) {
          if (bundleContainerDesktop) bundleContainerDesktop.style.display = 'none';
          if (bundleContainerMobile) bundleContainerMobile.style.display = 'none';
          return;
        }
        // Render for both desktop and mobile if both exist
        if (bundleContainerDesktop) {
          renderBundleSection(products, materialType, true);
        }
        if (bundleContainerMobile) {
          renderBundleSection(products, materialType, false);
        }
      })
      .catch(error => {
        console.error('Bundle loading error:', error);
        if (bundleContainerDesktop) bundleContainerDesktop.style.display = 'none';
        if (bundleContainerMobile) bundleContainerMobile.style.display = 'none';
      });
  });

  // Toggle function for mobile bundle collapse/expand
  window.toggleBundleContent = function(headerElement) {
    const bundleContent = headerElement.nextElementSibling;
    const toggleIcon = headerElement.querySelector('.bundle-toggle');
    const savingsLabel = headerElement.querySelector('.bundle-savings-label');
    const hintLabel = headerElement.querySelector('.bundle-hint-label');
    const bundleWrapper = headerElement.closest('.bundle-section-wrapper');

    if (!bundleContent || !toggleIcon) return;

    const isCollapsed = bundleContent.style.display === 'none' || bundleContent.style.display === '';

    if (isCollapsed) {
      bundleContent.style.display = 'block';
      toggleIcon.style.transform = 'rotate(180deg)';
      if (savingsLabel) savingsLabel.style.display = 'none';
      if (hintLabel) hintLabel.style.display = 'none';

      // Scroll to center the bundle section after a short delay to allow content to render
      setTimeout(() => {
        if (bundleWrapper) {
          bundleWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    } else {
      bundleContent.style.display = 'none';
      toggleIcon.style.transform = 'rotate(0deg)';
      if (savingsLabel) savingsLabel.style.display = 'block';
      if (hintLabel) hintLabel.style.display = 'block';
    }
  };

})();
